import * as Types from '../../@types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateTev2MonthlySongMutationVariables = Types.Exact<{
  seq: Types.Scalars['Int']['input'];
  year: Types.Scalars['Int']['input'];
  month: Types.Scalars['Int']['input'];
  tev2Banner: Types.Scalars['String']['input'];
  introductionBanner: Types.Scalars['String']['input'];
  vimeoId: Types.Scalars['String']['input'];
  tev2SongId: Types.Scalars['String']['input'];
}>;


export type UpdateTev2MonthlySongMutation = { __typename?: 'Mutation', updateTev2MonthlySong: { __typename?: 'Payload', count: number, error?: Types.Error | null } };


export const UpdateTev2MonthlySongDocument = gql`
    mutation UpdateTev2MonthlySong($seq: Int!, $year: Int!, $month: Int!, $tev2Banner: String!, $introductionBanner: String!, $vimeoId: String!, $tev2SongId: String!) {
  updateTev2MonthlySong(
    parameter: {seq: $seq, year: $year, month: $month, tev2Banner: $tev2Banner, introductionBanner: $introductionBanner, vimeoId: $vimeoId, tev2SongId: $tev2SongId}
  ) {
    count
    error
  }
}
    `;
export type UpdateTev2MonthlySongMutationFn = Apollo.MutationFunction<UpdateTev2MonthlySongMutation, UpdateTev2MonthlySongMutationVariables>;

/**
 * __useUpdateTev2MonthlySongMutation__
 *
 * To run a mutation, you first call `useUpdateTev2MonthlySongMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTev2MonthlySongMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTev2MonthlySongMutation, { data, loading, error }] = useUpdateTev2MonthlySongMutation({
 *   variables: {
 *      seq: // value for 'seq'
 *      year: // value for 'year'
 *      month: // value for 'month'
 *      tev2Banner: // value for 'tev2Banner'
 *      introductionBanner: // value for 'introductionBanner'
 *      vimeoId: // value for 'vimeoId'
 *      tev2SongId: // value for 'tev2SongId'
 *   },
 * });
 */
export function useUpdateTev2MonthlySongMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTev2MonthlySongMutation, UpdateTev2MonthlySongMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTev2MonthlySongMutation, UpdateTev2MonthlySongMutationVariables>(UpdateTev2MonthlySongDocument, options);
      }
export type UpdateTev2MonthlySongMutationHookResult = ReturnType<typeof useUpdateTev2MonthlySongMutation>;
export type UpdateTev2MonthlySongMutationResult = Apollo.MutationResult<UpdateTev2MonthlySongMutation>;
export type UpdateTev2MonthlySongMutationOptions = Apollo.BaseMutationOptions<UpdateTev2MonthlySongMutation, UpdateTev2MonthlySongMutationVariables>;